import { ReactNode, useEffect } from 'react';
import { useAirKeyTrace } from '@/utils/airKeyTrace';
import warningIcon from '@assets/Caution.svg';
import { colorBackgroundDisabled } from '@cof/omni-tokens';
import styled from '@emotion/styled';

interface ErrorScreenProps {
  title: string;
  body: string;
  action?: string;
  header?: string;
  helper?: ReactNode;
}

const ErrorScreenContainer = styled('div')`
  background-color: rgba(242, 242, 243, 1);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: top;
  padding: 2rem;
`;

const ErrorImageContainer = styled('div')`
  padding: 50px;
  border-radius: 100%;
  background-color: ${colorBackgroundDisabled};

  img {
    margin: 0;
  }
`;

const ErrorScreenTitle = styled('h3')`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

const ErrorScreenHeader = styled('header')`
  width: 100vw;
  background-color: rgba(1, 61, 91, 1);
  color: white;
  padding: 32px 32px 32px;
  margin-bottom: 30px;
  h1 {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    text-align: center;
    line-height: 30px;
  }
`;

const ErrorScreenBody = styled('div')`
  text-align: center;
`;

const ErrorScreenHelper = styled('div')`
  padding-top: 20px;
  text-align: center;
`;

/**
 * @deprecated only used for 3DS
 */
export const ErrorScreen_DEPRECIATED = ({
  title,
  body,
  header,
  action,
  helper,
}: ErrorScreenProps) => {
  const sendTrace = useAirKeyTrace();

  useEffect(() => {
    sendTrace({
      view: 'error',
      action: 'view_loaded',
      additionalData: {
        component: 'ErrorScreen_DEPRECIATED',
        action_type: action ?? 'ErrorScreen',
        title,
        body,
        header,
      },
    });
  }, [action, body, header, title]);

  return (
    <ErrorScreenContainer data-testid="ErrorScreen_DEPRECIATED">
      {header ? (
        <ErrorScreenHeader data-testid="ErrorScreen--Header">
          <h1>{header}</h1>
        </ErrorScreenHeader>
      ) : null}
      <ErrorImageContainer>
        <img src={warningIcon} width="66" alt="" role="presentation" />
      </ErrorImageContainer>
      <ErrorScreenTitle>{title}</ErrorScreenTitle>
      <ErrorScreenBody>{body}</ErrorScreenBody>
      {helper ? <ErrorScreenHelper>{helper}</ErrorScreenHelper> : null}
    </ErrorScreenContainer>
  );
};
